import Modal from 'shared/components/Modal/Modal';

export default Modal;
